import { render, staticRenderFns } from "./profile-controller.view.vue?vue&type=template&id=010fe48e&"
import script from "./profile-controller.view.vue?vue&type=script&lang=ts&"
export * from "./profile-controller.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports